export const extensionEvents = Object.freeze({
  GET_EXTENSIONS: 'get_extensions',
  EXTENSIONS: 'extensions',
  EXTENSION_RING: 'extension_ring',
  EXTENSION_RINGING: 'extension_ringing',
  EXTENSION_AVAILABLE: 'extension_available',
  EXTENSION_UNREGISTERED: 'extension_unregistered'
});
